<template>
  <EButton
    as="a"
    :href="url"
    variant="outline"
    size="s"
    rel="noopener"
    :target="linkTarget"
    class="ad-extension-action"
    data-test-id="ad-extension-action"
  >
    {{ title }}
  </EButton>
</template>

<script>
import { mapGetters } from 'vuex';

import EButton from '~~/common/vue/components/button';

export default {
  components: {
    EButton,
  },
  props: {
    url: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  computed: mapGetters('user', ['linkTarget']),
};
</script>
